import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './AdminBlogForm.css';
import { Slidar } from '../AdminDashbord/Slidar';
import { FaEdit } from "react-icons/fa";
import { MdAutoDelete } from "react-icons/md";

const AdminBlogForm = () => {
  const [title, setTitle] = useState('');
  const [caption, setCaption] = useState('');
  const [description, setDescription] = useState('');
  const [subParts, setSubParts] = useState(['']);
  const [image, setImage] = useState(null);
  const [blogs, setBlogs] = useState([]);
  const [editId, setEditId] = useState(null);
  const [showForm, setShowForm] = useState(false); // 👈 new toggle state
  const [dropdownOpenId, setDropdownOpenId] = useState(null);
  const [expandedBlogIds, setExpandedBlogIds] = useState([]);
  const [extraImages, setExtraImages] = useState([]); // NEW


  useEffect(() => {
    fetchBlogs();
  }, []);

  const fetchBlogs = async () => {
    const res = await axios.get('/api/blogs');
    setBlogs(res.data);
  };

const handleSubmit = async (e) => {
  e.preventDefault();
  const formData = new FormData();
  formData.append('title', title);
  formData.append('caption', caption);
  formData.append('description', description);
  formData.append('subParts', JSON.stringify(subParts));

  if (image) formData.append('image', image);

  if (extraImages.length > 0) {
    extraImages.forEach((file) => {
      formData.append('extraImages', file);
    });
  }

  try {
    if (editId) {
      await axios.put(`/api/blogs/${editId}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      alert('✅ Blog updated successfully!');
    } else {
      await axios.post('/api/blogs', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      alert('✅ Blog submitted successfully!');
    }

    // reset form
    setTitle('');
    setCaption('');
    setDescription('');
    setSubParts(['']);
    setImage(null);
    setExtraImages([]); // ✅ reset extra images
    setEditId(null);
    setShowForm(false);
    fetchBlogs();
  } catch (error) {
    console.error('Error:', error);
    alert('❌ Submission failed. Please try again.');
  }
};

const handleEdit = (blog) => {
  setTitle(blog.title);
  setCaption(blog.caption);
  setDescription(blog.description);
  setSubParts(blog.subParts);
  setEditId(blog._id);
  setShowForm(true);

  // we don’t preload file inputs, but we can show previews if needed
  setImage(null);
  setExtraImages([]);
};

const handleDelete = async (id) => {
  if (window.confirm('Are you sure to delete this blog?')) {
    await axios.delete(`/api/blogs/${id}`);
    fetchBlogs();
    alert('🗑️ Blog deleted');
  }
};

  return (
    <>
      <div className="d-flex">
        <Slidar />
        <div className="blog-form-container-flex">

          <div className="blog-form-content">

            {/* Toggle Button */}
            <div>
              <button className="toggle-form-button" onClick={() => {
                setShowForm(!showForm);
                if (!showForm) {
                  setEditId(null);
                  setTitle('');
                  setCaption('');
                  setDescription('');
                  setSubParts(['']);
                  setImage(null);
                }
              }}>
                {showForm ? '❌ Close Form' : '➕ Add Products'}
              </button>
            </div>

            {/* Conditionally show the form */}
            {showForm && (
              <>
                <h2>{editId ? '✏️ Edit Blog' : '📝 Add New Products'}</h2>
                <form onSubmit={handleSubmit} encType="multipart/form-data">
                  <input type="text" value={title} onChange={(e) => setTitle(e.target.value)} placeholder="Title" required />
                  <input type="text" value={caption} onChange={(e) => setCaption(e.target.value)} placeholder="Caption" required />
                  <textarea value={description} onChange={(e) => setDescription(e.target.value)} placeholder="Main Description" required />
                  {subParts.map((part, index) => (
                    <textarea
                      key={index}
                      value={part}
                      onChange={(e) => {
                        const updated = [...subParts];
                        updated[index] = e.target.value;
                        setSubParts(updated);
                      }}
                      placeholder={`Subpart ${index + 1}`}
                      required
                    />
                  ))}
                  <button type="button" onClick={() => setSubParts([...subParts, ''])}>➕ Add Subpart</button>
                {/* Main Image */}
<input 
  type="file" 
  accept="image/*" 
  onChange={(e) => setImage(e.target.files[0])} 
/>

{/* Extra Images - 4 separate inputs */}
{[0,1,2,3].map((idx) => (
  <input
    key={idx}
    type="file"
    accept="image/*"
    onChange={(e) => {
      const files = [...extraImages];
      files[idx] = e.target.files[0];
      setExtraImages(files);
    }}
  />
))}



                  <button type="submit">{editId ? '🔄 Update Products' : '🚀 Submit Products'}</button>
                </form>
              </>
            )}

   

            <h3 className='mt-2'>📚 Existing Products</h3>
            <div className="blog-list">
              {blogs.map((blog) => {
                const isDropdownOpen = dropdownOpenId === blog._id;
                const isExpanded = expandedBlogIds.includes(blog._id);

               

                return (
                  <div key={blog._id} className="blog-card">
                    {/* 3-Dots Menu */}
                    <button
                      className="card-menu"
                      onClick={() =>
                        setDropdownOpenId(isDropdownOpen ? null : blog._id)
                      }
                    >
                      ⋮
                    </button>

                    {isDropdownOpen && (
                      <div className="card-dropdown">
                        <button onClick={() => handleEdit(blog)}><FaEdit color="black" /></button>
                        <button onClick={() => handleDelete(blog._id)}><MdAutoDelete color="black" /></button>
                      </div>
                    )}

                    <h4>{blog.title}</h4>
                    <p><strong>Caption:</strong> {blog.caption}</p>

                    <p>
                      <strong>Description:</strong>{' '}
                      {isExpanded ? blog.description : `${blog.description.slice(0, 50)}...`}
                    </p>


                    {blog.subParts?.length > 0 && (
                      <div>
                        <strong>SubParts:</strong>
                        <ul>
                          {blog.subParts.map((part, idx) => (
                            <li key={idx}>{part}</li>
                          ))}
                        </ul>
                      </div>
                    )}

                    {/* ✅ Read More button at the bottom right */}
                    {blog.description.length > 100 && (
                      <div style={{ marginTop: 'auto', textAlign: 'right' }}>
                        <button
                          style={{
                            backgroundColor: '#eee',
                            color: '#333',
                            fontSize: '12px',
                            padding: '6px 12px',
                            borderRadius: '6px',
                            border: 'none',
                            cursor: 'pointer',
                          }}
                          onClick={() => {
                            if (expandedBlogIds.includes(blog._id)) {
                              setExpandedBlogIds(expandedBlogIds.filter(id => id !== blog._id));
                            } else {
                              setExpandedBlogIds([...expandedBlogIds, blog._id]);
                            }
                          }}
                        >
                          {isExpanded ? '🔼 Read Less' : '🔽 Read More'}
                        </button>
                      </div>
                    )}


                   {blog.imagePath && (
  <img
    src={`/uploads/${blog.imagePath}`}
    alt="Main"
    style={{ width: "200px", marginBottom: "10px" }}
  />
)}

{/* Show extra images */}
{blog.extraImages && blog.extraImages.length > 0 && (
  <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
    {blog.extraImages.map((img, idx) => (
      <img
        key={idx}
        src={`/uploads/${img}`}
        alt={`Extra ${idx + 1}`}
        style={{ width: "100px", height: "100px", objectFit: "cover" }}
      />
    ))}
  </div>
)}

                  </div>
                );
              })}


            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminBlogForm;
